import {
  apiData,
  apiRequest
} from "./http.js";


function normalizeRemoteSettings(data) {
  return {
    difficulty: data.difficulty,
    soundEnabled: data.sound_enabled,
    ballSpeedPreset: data.ball_speed_preset,
    languageCode: data.language_code,
    ballSkinCode: data.ball_skin_code,
    paddleSkinCode: data.paddle_skin_code
  };
}


function buildSettingsPatch(patch) {
  const body = {};

  if ("difficulty" in patch) {
    body.difficulty = patch.difficulty;
  }

  if ("soundEnabled" in patch) {
    body.sound_enabled =
      patch.soundEnabled;
  }

  if ("ballSpeedPreset" in patch) {
    body.ball_speed_preset =
      patch.ballSpeedPreset;
  }

  if ("languageCode" in patch) {
    body.language_code =
      patch.languageCode;
  }

  if ("ballSkinCode" in patch) {
    body.ball_skin_code =
      patch.ballSkinCode;
  }

  if ("paddleSkinCode" in patch) {
    body.paddle_skin_code =
      patch.paddleSkinCode;
  }

  return body;
}


export async function getGameSettings() {
  const data = apiData(
    await apiRequest(
      "/api/game/settings"
    )
  );

  return normalizeRemoteSettings(data);
}


export async function updateGameSettings(
  patch
) {
  const data = apiData(
    await apiRequest(
      "/api/game/settings",
      {
        method: "PATCH",
        body: buildSettingsPatch(patch)
      }
    )
  );

  return normalizeRemoteSettings(data);
}
